import { ComplianceTypes } from '@/constants';

import { RootState } from '../store';
import { ONBOARDING_SLICE_KEY } from './onboarding.slice';
import { OnboardingForm, STEP_IDS } from './onboarding.types';

export const selectOnboardingForm = (state: RootState) =>
  state[ONBOARDING_SLICE_KEY].form;

export const selectOnboardingActiveStep = (state: RootState) =>
  state[ONBOARDING_SLICE_KEY].activeStep;

export const selectOnboardingActiveStepInput = (state: RootState) => {
  const activeStep = state[ONBOARDING_SLICE_KEY].activeStep;
  const stepInputs = state[ONBOARDING_SLICE_KEY].stepInputs;
  return stepInputs[activeStep].value;
};

export const selectOnboardingStepInputs = (state: RootState) =>
  state[ONBOARDING_SLICE_KEY].stepInputs;

// TODO use this?
export const selectOnboardingStepInput =
  (step: keyof typeof STEP_IDS) => (state: RootState) =>
    state[ONBOARDING_SLICE_KEY].stepInputs[step];

export const selectOnboardingUserCompliance = (state: RootState) => {
  const form = selectOnboardingForm(state);
  return getDesignationComplianceType(form);
};

export const getDesignationComplianceType = (form: OnboardingForm) => {
  if (form.designations?.USA?.CPA) return ComplianceTypes.CPE;
  if (form.designations?.CAN?.CPA) return ComplianceTypes.CPD;
  if (Object.values(form.designations?.USA || {}).length)
    return ComplianceTypes.CPE;
  if (Object.values(form.designations?.CAN || {}).length)
    return ComplianceTypes.CPD;
  return ComplianceTypes.CPD;
};

export const selectIsHandlingStepTransition = (state: RootState) =>
  state[ONBOARDING_SLICE_KEY].isHandlingStepTransition;
